module.exports = __webpack_public_path__ + "static/2-24e05d6dd15831474da458afb7bb64a8.jpg";